import gql from 'graphql-tag';

export const dashboardAppInfoByTime = gql`
  query ($applicationId: Int, $type: String) {
    dashboardAppInfoByTime(applicationId: $applicationId, type: $type) {
      byTime
      total
      groupBy
    }
  }
`
